import io from "socket.io-client";
const max_socket_reconnects = 6;

const Apiconfig = {
  baseUrl: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
  redirectlogin: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_REDIRECT_URL || process.env.REACT_APP_REDIRECT_URL,
  cryptoKey: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_CRYPTO_KEY || process.env.REACT_APP_CRYPTO_KEY,
  bankRecHelp: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_BANKREC_HELP_URL || process.env.REACT_APP_BANKREC_HELP_URL,
  clientFundsHelp: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_CLIENTFUNDS_HELP_URL || process.env.REACT_APP_CLIENTFUNDS_HELP_URL,
  emailSupport: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_EMAIL_SUPPORT_URL || process.env.REACT_APP_EMAIL_SUPPORT_URL,
  recApi: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_RECAPI_URL || process.env.REACT_APP_RECAPI_URL,
  allowCoSpecialChars: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_ALLOW_SPECIALCHARS_COID || process.env.REACT_APP_ALLOW_SPECIALCHARS_COID,
  taxCodeExistHelp: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_TAXCODE_EXIST_HELP_URL || process.env.REACT_APP_TAXCODE_EXIST_HELP_URL,
  empFundHelp: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_EMPFUND_HELP_URL || process.env.REACT_APP_EMPFUND_HELP_URL,
  otherImpFileSize: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_OTHER_IMPORT_FILE_SIZE_LIMIT || process.env.REACT_APP_OTHER_IMPORT_FILE_SIZE_LIMIT,
  dropSizeLimit: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_DROP_FILE_SIZE_LIMIT || process.env.REACT_APP_DROP_FILE_SIZE_LIMIT,
  ewaDropSizeLimit: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_EWA_DROP_FILE_SIZE_LIMIT || process.env.REACT_APP_EWA_DROP_FILE_SIZE_LIMIT,
  ewaOtherImpFileSize: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_EWA_OTHER_IMPORT_FILE_SIZE_LIMIT || process.env.REACT_APP_EWA_OTHER_IMPORT_FILE_SIZE_LIMIT,
  appMapKey: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_MAP_KEY || process.env.REACT_APP_MAP_KEY,
  nodeEnv: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.NODE_ENV || process.env.NODE_ENV,
  publicURL: window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.PUBLIC_URL || process.env.PUBLIC_URL
};

export const socket = io.connect(Apiconfig.baseUrl ,{
  rememberTransport: false,
  transports: ['websocket', "polling"],
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax : 2000,
  reconnectionAttempts: Infinity
 });
 
socket.on("reconnect_attempt", attempt => {
  console.log("Reconnect attempt:", attempt);
});

socket.on('reconnect', () => {
  console.log('Socket reconnected');
  /** START: Bug 5152: Data crossing tenants */
  const sessSockInfo = sessionStorage.getItem("sessionInfo")
  let sessionOrgId = typeof sessSockInfo === 'string' && sessSockInfo.trim() ? parseInt(sessSockInfo.trim()) : null;
  socket.emit("MessageFromPlatformHR", {
    token: localStorage.getItem("token"),
    sessionOrgId
  });
  /** END: Bug 5152: Data crossing tenants */
});

// Join room on initial connection
socket.on("connect", () => {
  console.log("Connected:", socket.id);
});

socket.on("disconnect", reason => {
  console.log("disconnect due to " + reason);
});

socket.on("connect_error", (err) => {
  console.log(`connect_error due to ${err.message}`);
});

export default Apiconfig;
